import React, { Component } from "react";
import styles from "./Layouts.local.scss";
import classnames from "classnames";
import { ComponentFactory } from "../Components/ComponentFactory";
import {
  hasExplanation,
  checkAndGetExplanations,
  checkForComments
} from "Utils";

//  ________________________________
// |                                |
// |________________________________|
// |                                |
// |                                |
// |                                |
// |________________________________|

class Layout8 extends Component {
  render() {
    const {
      slideId,
      selectedComponent,
      layoutData: { components },
      componentsBackground,
      isResponsive,
      isComposition,
      isPresentation,
      comments,
      explanations,
      isPreparePresentation,
      indicators,
      lng
    } = this.props;

    const customBackground = {
      background: componentsBackground
    };

    return (
      <div className={`row ${styles.layout}`}>
        <div
          className={`large-12 medium-12 small-12 ${styles.component_block}`}
        >
          <div className={`${styles.flex_container}`}>
            <div
              className={classnames(
                isResponsive ? "large-12 medium-12 small-12" : "small-12",
                styles.component_block,
                styles.flex_container,
                styles.align_container,
                isComposition === false &&
                  components[1] !== undefined &&
                  (selectedComponent === components[1].componentId
                    ? styles.gradient_border
                    : "")
              )}
            >
              <div
                className={classnames(
                  styles.component_container,
                  styles.container_s_height
                )}
                style={customBackground}
              >
                {/********** Component n°1 ********/}

                <ComponentFactory
                  component={components[1]}
                  layoutProps={{
                    customBackground: customBackground
                  }}
                  ComponentCase={"1"}
                  isComposition={isComposition}
                  isPresentation={isPresentation}
                  isPreparePresentation={isPreparePresentation}
                  hasComments={
                    isPresentation &&
                    checkForComments(components[1], comments, slideId)
                  }
                  indicatorsExplanation={
                    isPresentation || isComposition
                      ? checkAndGetExplanations(
                          components[1],
                          explanations,
                          indicators,
                          lng
                        )
                      : null
                  }
                  hasExplanation={
                    (isPresentation || isComposition) &&
                    hasExplanation(components[1])
                  }
                  {...this.props}
                />
              </div>
            </div>
            <div
              className={classnames(
                isResponsive ? "large-12 medium-12 small-12" : "small-12",
                styles.component_block,
                styles.flex_container,
                styles.align_container,
                isComposition === false &&
                  components[2] !== undefined &&
                  (selectedComponent === components[2].componentId
                    ? styles.gradient_border
                    : "")
              )}
            >
              <div
                className={classnames(
                  styles.component_container,
                  styles.container_l_height
                )}
                style={customBackground}
              >
                {/********** Component n°2 ********/}

                <ComponentFactory
                  component={components[2]}
                  layoutProps={{
                    customBackground: customBackground,
                    scaleComponent: true,
                    containerHeight: 300
                  }}
                  ComponentCase={"2"}
                  isComposition={isComposition}
                  isPresentation={isPresentation}
                  isPreparePresentation={isPreparePresentation}
                  hasComments={
                    isPresentation &&
                    checkForComments(components[2], comments, slideId)
                  }
                  indicatorsExplanation={
                    isPresentation || isComposition
                      ? checkAndGetExplanations(
                          components[2],
                          explanations,
                          indicators,
                          lng
                        )
                      : null
                  }
                  hasExplanation={
                    (isPresentation || isComposition) &&
                    hasExplanation(components[2])
                  }
                  {...this.props}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Layout8;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/Layout8.js